import { inject, Injectable } from '@angular/core';
import {
  ApiDataAccess, ApiResourceLocation,
  Dictionary,
  ReadonlyHttpApiListRepository,
  Result,
} from '@softline/core';
import {
  SOFTLINE_API_DFH_DATA_CARRIER_SUPPLIER_COLUMNS,
  SOFTLINE_API_DFH_DATA_CARRIER_UPDATE_SUPPLIER_COLUMNS,
} from '../bauprofi.api';
import { DataCarrierColumns } from '../types/data-carrier-columns';

export interface BauprofiDataCarrierColumnsQuery {
  format: string;
}

@Injectable()
export class BauprofiDataCarrierColumnsRepository extends ReadonlyHttpApiListRepository<
  Result<DataCarrierColumns[]>,
  BauprofiDataCarrierColumnsQuery | undefined
> {
  constructor() {
    super(inject(ApiDataAccess), SOFTLINE_API_DFH_DATA_CARRIER_SUPPLIER_COLUMNS);
  }

  override getLoadPathParams(
    params: BauprofiDataCarrierColumnsQuery
  ): Dictionary<unknown> {
    return {
      format: params.format,
    };
  }

  async updateSelectedFiles(body: DataCarrierColumns[]) {
    const location = {
      path: SOFTLINE_API_DFH_DATA_CARRIER_UPDATE_SUPPLIER_COLUMNS,
    } as ApiResourceLocation;

      await
        this.dataAccess.update<
          DataCarrierColumns[],
          DataCarrierColumns[]
        >(location, body);
    }
}
